import { Link } from 'react-router-dom';
import useFeatureFlags from 'app/hooks/useFeatureFlags';
import OstroDynamicContent from 'app/components/OstroDynamicContent';

import { Body } from '../../../components/Typography';
import { ModuleItem, ModuleItemActionType } from '../../../services/helpCenter';
import useLinks from '../hooks/useLinks';
import SingleCTA from './CTA/SingleCTA';

export default function TailorHorizontalButtons({
  title,
  buttons,
  onClickButton,
  className,
}: {
  title?: string;
  buttons?: ModuleItem[];
  onClickButton?: (button: ModuleItem) => void;
  className?: string;
}) {
  const { getLinkTarget, openLink } = useLinks();
  const featureFlags = useFeatureFlags();

  const filteredButtons = buttons?.filter(
    (button) =>
      !(
        button.action_obj.action_type === ModuleItemActionType.OPEN_VIRTUAL_ASSISTANT &&
        !featureFlags.uiEngagementHubConversationalAi
      )
  );

  const handleClick = (e: React.MouseEvent<HTMLElement>, button: ModuleItem) => {
    if (button.action_obj.action_type !== ModuleItemActionType.OPEN_VIRTUAL_ASSISTANT) {
      e.preventDefault();
      openLink(button.action_obj.url, { linkLocation: 'dynamicButton' });
    }

    onClickButton && onClickButton(button);
  };

  if (!filteredButtons || filteredButtons.length === 0) return null;

  return (
    <div
      id="ostro-horizontal-container"
      className={className}
    >
      {title && <Body className="mb-4">{title}</Body>}
      <div className="flex gap-4">
        {filteredButtons.map((button) => {
          const { target, url } =
            button.action_obj.action_type === ModuleItemActionType.OPEN_VIRTUAL_ASSISTANT
              ? { target: '_self', url: '/virtual-assistant' }
              : { target: getLinkTarget(button.action_obj.url), url: button.action_obj.url };

          if (filteredButtons.length === 1) {
            return (
              <SingleCTA
                key={button.title}
                title={button.title}
                description={button.description}
                link={url}
                unreadMessageCount={0}
                imgAlt={`${button.title} icon`}
                imgSrc={button.icon}
                onClick={(e) => handleClick(e, button)}
                target={target}
              />
            );
          }

          return (
            <Body
              component={Link}
              key={button.title}
              to={url}
              target={target}
              rel="noreferrer"
              className="ostro-dynamic-button bg-white rounded-2xl px-[18px] py-2 inline-block text-center w-full flex items-center justify-center"
              onClick={(e) => handleClick(e, button)}
            >
              {button.icon && (
                <img
                  className="h-[14px] block mx-auto mb-1"
                  src={button.icon}
                  alt={`${button.title} icon`}
                />
              )}
              <OstroDynamicContent
                component="span"
                className="inline"
                content={button.title}
              />
            </Body>
          );
        })}
      </div>
    </div>
  );
}
